module.exports = __webpack_public_path__ + "static/media/level-icon.f6c678f3.svg";